<main class="kebab-wrapper">
  <button type="button" class="kebab-container" (click)="dropDownKebab($event)">  
    <lucide-icon class="kebab" name="ellipsis"></lucide-icon>
  </button>
  <section *ngIf="isActive" class="dropdown-container" (click)="$event.stopPropagation()">
    <app-kebab-favourite-component (toggleChange)="closeMenu()" [data]="data"></app-kebab-favourite-component>
    <app-kebab-watch-to-list-component (toggleChange)="closeMenu()" [data]="data"></app-kebab-watch-to-list-component> 
    <app-kebab-list-component (toggleChange)="closeMenu()" [data]="data"></app-kebab-list-component>
    <app-kebab-rating-component (toggleChange)="closeMenu()" [data]="data"></app-kebab-rating-component>
  </section>
</main>
